import { action, createRequestTypes } from '../base';

export const templateRouteActionTypes = {
  GET_TEMPLATE_ROUTES: createRequestTypes('GET_TEMPLATE_ROUTES'),
  GET_TEMPLATE_ROUTE_BY_ID: createRequestTypes('GET_TEMPLATE_ROUTE_BY_ID'),
  CREATE_TEMPLATE_ROUTE: createRequestTypes('CREATE_TEMPLATE_ROUTE'),
  UPDATE_TEMPLATE_ROUTE: createRequestTypes('UPDATE_TEMPLATE_ROUTE'),
  UPDATE_ASSIGNEE: createRequestTypes('UPDATE_ASSIGNEE'),
  UPDATE_STATUS_TEMPLATE_ROUTE: createRequestTypes('UPDATE_STATUS_TEMPLATE_ROUTE'),
  DELETE_TEMPLATE_ROUTE: createRequestTypes('DELETE_TEMPLATE_ROUTE'),
};

/**
 * @param payload
 * @param orgId
 * @param status
 * @param limit
 * @param page
 * @param callback
 */
class TemplateRouteActions {
  /**
   * @param {*} orgId
   * @param {*} searchKeyword
   * @param {*} page
   * @param {*} limit
   * @return
   */
  getTemplateRoutes = (orgId, page, limit, searchKeyword, tenants) => action(templateRouteActionTypes.GET_TEMPLATE_ROUTES.REQUEST, {
    orgId, page, limit, searchKeyword, tenants,
  });

  /**
   *
   * @param {*} getTemplateRoutesLoading
   * @return
   */
  getTemplateRoutesLoading = (getTemplateRoutesLoading) => action(templateRouteActionTypes.GET_TEMPLATE_ROUTES.LOADING, {
    getTemplateRoutesLoading,
  });

  /**
   * @return
   * @param templateRoutes
   */
  getTemplateRoutesSuccess = (templateRoutes) => action(templateRouteActionTypes.GET_TEMPLATE_ROUTES.SUCCESS, {
    templateRoutes,
  });

  /**
   * @param orgId
   * @param {*} templateRouteId
   * @return
   */
  getTemplateRouteById = (orgId, templateRouteId, callback) => action(templateRouteActionTypes.GET_TEMPLATE_ROUTE_BY_ID.REQUEST, {
    orgId, templateRouteId, callback,
  });

  /**
   *
   * @param {*} getTemplateRouteByIdLoading
   * @return
   */
  getTemplateRouteByIdLoading = (getTemplateRouteByIdLoading) => action(templateRouteActionTypes.GET_TEMPLATE_ROUTE_BY_ID.LOADING, {
    getTemplateRouteByIdLoading,
  });

  /**
   * @return
   * @param selectedTemplateRoute
   * @param templateRouteData
   */
  getTemplateRouteByIdSuccess = (selectedTemplateRoute) => action(templateRouteActionTypes.GET_TEMPLATE_ROUTE_BY_ID.SUCCESS, {
    selectedTemplateRoute,
  });

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  createTemplateRoute = (payload, callback) => action(templateRouteActionTypes.CREATE_TEMPLATE_ROUTE.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} createTemplateRouteLoading
   * @return
   */
  createTemplateRouteLoading = (createTemplateRouteLoading) => action(templateRouteActionTypes.CREATE_TEMPLATE_ROUTE.LOADING, {
    createTemplateRouteLoading,
  });

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateTemplateRoute = (payload, callback) => action(templateRouteActionTypes.UPDATE_TEMPLATE_ROUTE.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} updateTemplateRouteLoading
   * @return
   */
  updateTemplateRouteLoading = (updateTemplateRouteLoading) => action(templateRouteActionTypes.UPDATE_TEMPLATE_ROUTE.LOADING, {
    updateTemplateRouteLoading,
  });

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateTemplateRouteStatus = (payload, callback) => action(templateRouteActionTypes.UPDATE_STATUS_TEMPLATE_ROUTE.REQUEST, {
    payload, callback,
  });

  /**
   * @param updateTemplateRouteStatusLoading
   * @return {{type: *}}
   */
  updateTemplateRouteStatusLoading = (updateTemplateRouteStatusLoading) => action(templateRouteActionTypes.UPDATE_STATUS_TEMPLATE_ROUTE.LOADING, {
    updateTemplateRouteStatusLoading,
  });

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deleteTemplateRoute = (payload, callback) => action(templateRouteActionTypes.DELETE_TEMPLATE_ROUTE.REQUEST, {
    payload, callback,
  });

  /**
   * @param deleteTemplateRouteLoading
   * @return {{type: *}}
   */
  deleteTemplateRouteLoading = (deleteTemplateRouteLoading) => action(templateRouteActionTypes.DELETE_TEMPLATE_ROUTE.LOADING, {
    deleteTemplateRouteLoading,
  });

  /**
  *
  * @param {*} payload
  * @param {*} callback
  * @return
  */
  updateAssignee = (payload, callback) => action(templateRouteActionTypes.UPDATE_ASSIGNEE.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} updateAssigneeLoading
   * @return
   */
  updateAssigneeLoading = (updateAssigneeLoading) => action(templateRouteActionTypes.UPDATE_ASSIGNEE.LOADING, {
    updateAssigneeLoading,
  });
}

export default new TemplateRouteActions();
